// Шлюз однократной проверки доступа к адресу рельса, отсутствующему в локальном каталоге
// (T-SHELL-OPENPRODUCT-STORM): прямой заход на продукт без экрана (паспорт без front — media
// и подобные kind:system без menu_items, см. .claude/tasks.md QA 20.10 в) или вовсе на
// неустановленный слаг даёт activeEntryId, которого нет в products, и POST /api/products?id=
// должен уйти РОВНО ОДИН раз на конкретный id за время жизни вкладки — не на каждое срабатывание
// эффекта: ссылка products меняется на каждый живой кадр рельса (счётчик/статус ЛЮБОГО другого
// продукта, useProducts.ts), даже когда состав каталога не поменялся, и без этого шлюза эффект
// в useProductMenu.ts штормил бы ядро повторным POST при каждом таком кадре.
export function createAccessGate() {
    // id → denied (POST уже отыграл для этого id в этой сессии вкладки).
    const resolved = new Map();
    return {
        // true — id ещё не проверялся, можно звать openProduct.
        shouldCheck(id) {
            return !resolved.has(id);
        },
        // Готовый результат для id, уже проверенного ранее (повторный заход на ту же дверь в этой
        // сессии не бьёт в ядро заново) — undefined, если shouldCheck(id) === true.
        cached(id) {
            return resolved.get(id);
        },
        markResolved(id, denied) {
            resolved.set(id, denied);
        },
    };
}
